import { ConditionsNew } from '@retail/calculus/types';

export const getConditionFromType = (condition: ConditionsNew) => {
  switch (condition.type) {
    case 'PURCHASE':
      return condition.purchaseCondition;
    case 'FREIGHT':
      return condition.freightCondition;
    case 'MARKUP':
      return condition.markupCondition;
    case 'PRICE_SOURCE':
      return condition.priceSourceCondition;
    case 'CUSTOMER_MARKUP':
      return condition.customerMarkupCondition;
    case 'ROUNDING':
      return condition.roundingCondition;

    default:
      return undefined;
  }
};
